/* eslint-disable no-console */
import React from 'react';
// core components
import GridItem from 'components/UI/Grid/GridItem';
import GridContainer from 'components/UI/Grid/GridContainer';
// our components
import { useQueryString } from 'helpers/effects';
import PromotedAdList from 'components/PromotedAd/List';

const ScreenPromotedAdList = () => {
  const initialFilters = useQueryString();
  return (
    <GridContainer>
      <GridItem xs={12}>
        <PromotedAdList initialFilters={initialFilters} />
      </GridItem>
    </GridContainer>
  );
};

export default ScreenPromotedAdList;
